import React from "react";
import { IMAGES } from "../../utils/images";
import "../../Styles/DashboardLiveSessions.css";
const DashboardLiveSessions = () => {
  return (
    <div className="dashboard-content">
      <div className="home-heading-container">
        <h1 className="heading-text-h1">Live Sessions</h1>
      </div>
      <hr className="dashboard-home-hr" />
      <div className="livecard">
        <div className="livecard-left">
          <h2 className="completed-tag">Completed</h2>
          <h1 className="livecard-title">Lorem Ipsum Iwevs</h1>
          <div className="livecard-body">
            <p className="livecard-text">
              <img src={IMAGES.HOME_ICON_4} />
              10:00 AM - 1:00 PM
            </p>
            <p className="livecard-text">
              <img src={IMAGES.CALENDER_ICON} /> 19/02/2025
            </p>
          </div>
        </div>
        <button className="live-btn">
          <img src={IMAGES.PLAY_ICON} />
          View Recording
        </button>
      </div>
      <div className="livecard">
        <div className="livecard-left">
          <h2 className="live-tag">Live</h2>
          <h1 className="livecard-title">Lorem Ipsum Iwevs</h1>
          <div className="livecard-body">
            <p className="livecard-text">
              <img src={IMAGES.HOME_ICON_4} />
              10:00 AM - 1:00 PM
            </p>
            <p className="livecard-text">
              <img src={IMAGES.CALENDER_ICON} /> 19/02/2025
            </p>
          </div>
        </div>
        <button className="live-btn">
          <img src={IMAGES.PLAY_ICON} />
          View Session
        </button>
      </div>
      <div className="livecard">
        <div className="livecard-left">
          <h2 className="upcoming-tag">Up Coming</h2>
          <h1 className="livecard-title">Lorem Ipsum Iwevs</h1>
          <div className="livecard-body">
            <p className="livecard-text">
              <img src={IMAGES.HOME_ICON_4} />
              10:00 AM - 1:00 PM
            </p>
            <p className="livecard-text">
              <img src={IMAGES.CALENDER_ICON} /> 19/02/2025
            </p>
          </div>
        </div>
        <button className="upcoming-btn">
          <img src={IMAGES.LOCK_ICON} />
          View Session
        </button>
      </div>
    </div>
  );
};

export default DashboardLiveSessions;
